import { mergeAttributes, Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

import AssetTokenNode from "./AssetTokenNode";

export default Node.create({
  name: "assetComponent",

  group: "inline",

  inline: true,

  selectable: false,
  atom: true,

  parseHTML() {
    return [
      {
        tag: "asset-component",
      },
    ];
  },

  addAttributes() {
    return {
      data: {
        parseHTML: (element) => {
          const dataAttr = element.getAttribute("data");
          try {
            return dataAttr ? JSON.parse(dataAttr) : null;
          } catch {
            return null;
          }
        },
        renderHTML: (attributes) => {
          return {
            data: JSON.stringify(attributes.data),
          };
        },
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ["asset-component", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(AssetTokenNode, {
      contentDOMElementTag: "span",
    });
  },
});
